import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=2507a58a&scoped=true&"
import script from "./CommonDialog.vue?vue&type=script&lang=js&"
export * from "./CommonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2507a58a",
  null
  
)

export default component.exports